module.exports = __webpack_public_path__ + "static/images/containers/Challenges/images/glow-message.ccceca39.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/images/glow-message.png
// module id = 2872
// module chunks = 11